angular.module('dpw.services')
    .factory('seoService', [function () {
        return {
            from: {
                siteWide: 'siteWide',
                pageSpecific: 'pageSpecific'
            },
            updateBasicHeadInfo: function (title, keywords, description, from) {
                this.updateTitle(title, from);
                this.updateKeywords(keywords, from);
                this.updateDescription(description, from);
            },

            updateTitle: function (title, from) {
                var el = $('head title');
                var shouldUpdate = this.shouldUpdate(el, from);

                if (shouldUpdate) {
                    document.title = title;
                }

                this.updateOpenGraphTitle(title, from);
            },

            addMetaTags: function (tags) {
                this.addBasicOpenGraph();
                this.addArbitraryMeta(tags);
            },

            addArbitraryMeta: function (tags) {
                var metaHTML = '';

                tags.forEach(function (tag) {
                    var attributes = [];

                    _.forOwn(tag, function (value, key) {
                        attributes.push(key + '="' + value + '"');
                    });

                    metaHTML += '<meta ' + attributes.join(' ') + '>';
                });

              $(metaHTML).insertBefore('head title');
            },

            addBasicOpenGraph: function () {
                var tags = [
                    {
                        property: "og:title",
                        content: document.title
                    },
                    {
                        property: "og:url",
                        content: document.location.href.split('?')[0]
                    }
                ];
                this.addArbitraryMeta(tags);
            },

            /**
             * @param {object[]} tags
             * @param from
             */
            updateMetaTags: function (tags, from) {
              var self = this;

              tags = Array.isArray(tags) ? tags : [tags];
              tags.forEach(function (tag) {
                // Only support meta that has a name or property attribute.
                var query = '';

                if (tag.hasOwnProperty('name')) {
                  query = 'name="' + tag.name + '"';
                } else if (tag.hasOwnProperty('property')) {
                  query = 'property="' + tag.property + '"';
                }

                if (query) {
                  var el = $('meta[' + query + ']');
                  var shouldUpdate = self.shouldUpdate(el, from);
                  if (shouldUpdate) {
                    el.attr('content', tag.content);
                  }
                }
              });
            },

            updateOpenGraphTitle: function (title, from) {
                this.updateMetaTags({
                  property: 'og:title',
                  content: title
                }, from);
            },

            updateKeywords: function (keywords, from) {
                this.updateMetaTags({
                  name: 'keywords',
                  content: keywords
                }, from);
            },

            updateDescription: function (description, from) {
              this.updateMetaTags({
                name: 'description',
                content: description
              }, from);
            },

            shouldUpdate: function (element, from) {
                var shouldUpdate = from === this.from.pageSpecific ||
                    element.data('from') !== this.from.pageSpecific;

                if (shouldUpdate) {
                    element.data('from', from);
                }

                return shouldUpdate;
            }
        };
    }]);
